import api from './api.js';

class Colleagues {
    constructor(){
        this.url_colleagues = 'Colleagues'
    }
    get(data){
        return api.get(`${this.url_colleagues}/${data.id}`);
    }
    all(){
        return api.get(`${this.url_colleagues}/`);
    }
    getDataSource(id){
        return api.getDataSource(`${this.url_colleagues}`, id);
    }  
    create(data){
        return api.put(`${this.url_colleagues}/`, data);
    }
    update(data){
        return api.put(`${this.url_colleagues}/${data.id}/Status`, data);
    }
}

export default new Colleagues;
